export const IpcPortalRoutes = [
    {
        "url": "/ipcportal?inum",
        "name": "ipc-portal",
        "loginRequired": true,
        "type": "frontend",
        "params": {
            inum: { dynamic: true }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['ipc-portal'],
        },
        "component": 'ipcPortalContainer',
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/ipc-portal/ipc-portal.downgrade.module");
                }
            },
        ],
        "onEnter": ['brandServices', 'hUser', '$state', async (brandServices, hUser, $state) => {
                return new Promise(async (resolve, reject) => {
                    const isIPCServiceEnabled = await brandServices.check(brandServices.SERVICES.IPC_INTEGRATION, hUser.getUserContext().brand_id);
                    if (isIPCServiceEnabled) {
                        resolve();
                    }
                    else {
                        reject();
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }],
    }
];
//# sourceMappingURL=ipc-portal.routes.js.map